<template>
  <div class="">
    <div id="mp" >

      <dashboard-navbar></dashboard-navbar>
      <!-- your content here -->
      <router-view></router-view>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
  },
};
</script>
<style lang="scss">
/* total width */
body::-webkit-scrollbar {
  background-color: rgba(50, 50, 93, 0.24);
  width: 7px;
}

/* background of the scrollbar except button or resizer */
body::-webkit-scrollbar-track {
  background-color: rgba(50, 50, 93, 0.14);
}

/* scrollbar itself */
body::-webkit-scrollbar-thumb {
  background-color: rgba(218, 18, 18, 0.05);
  border-radius: 16px;
  border: 4px solid rgba(50, 50, 93, 0.79);
}
</style>
